class MobileCartCheckout extends HTMLElement {
  connectedCallback() {
    this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
    this.onPageShow = (event) => { if (event.persisted) this.refresh(); };
    window.addEventListener('pageshow', this.onPageShow);

    const inlineCheckout = document.getElementById('checkout');
    if (inlineCheckout) {
      this.checkoutObserver = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting && this.contains(document.activeElement)) {
          inlineCheckout.focus({ preventScroll: true });
        }
        this.toggleAttribute('data-inline-checkout-visible', entry.isIntersecting);
        this.inert = entry.isIntersecting;
      });
      this.checkoutObserver.observe(inlineCheckout);
    }
  }

  disconnectedCallback() {
    this.unsubscribe?.();
    window.removeEventListener('pageshow', this.onPageShow);
    this.controller?.abort();
    this.checkoutObserver?.disconnect();
  }

  async refresh() {
    this.controller?.abort();
    const controller = new AbortController();
    this.controller = controller;
    this.setAttribute('aria-busy', 'true');
    this.querySelector('button')?.setAttribute('disabled', '');

    try {
      const response = await fetch(`${routes.cart_url}?section_id=mobile-cart-checkout`, {
        signal: controller.signal,
        cache: 'no-store',
      });
      if (!response.ok) throw new Error('Could not refresh checkout');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const checkout = html.querySelector('mobile-cart-checkout');
      if (!checkout) throw new Error('Missing checkout section');
      if (controller.signal.aborted) return;
      this.innerHTML = checkout.innerHTML;
      this.querySelector('button')?.setAttribute('form', document.getElementById('cart') ? 'cart' : 'MobileCheckoutForm');
      this.hidden = false;
    } catch (error) {
      // Hide stale checkout details if refresh fails; the cart link remains available.
      if (!controller.signal.aborted) this.hidden = true;
    } finally {
      if (this.controller === controller) this.removeAttribute('aria-busy');
    }
  }
}

customElements.define('mobile-cart-checkout', MobileCartCheckout);
